import $ from 'jquery';
import { gsap } from 'gsap';

import { ManagePage } from '../Manage/_ManagePage.js';

(() => {

  // const managePage = new ManagePage();

  $('.guide-btn-op').click(function (e) {
    ManagePage.setPage(0);
    e.preventDefault();
  });

  $('.guide-btn1').click(function (e) {
    ManagePage.setPage(1);
    e.preventDefault();
  });

  $('.guide-btn2').click(function (e) {
    ManagePage.setPage(2);
    e.preventDefault();
  });

  $('.guide-btn3').click(function (e) {
    ManagePage.setPage(3);
    e.preventDefault();
  });

  $('.guide-btn4').click(function (e) {
    ManagePage.setPage(4);
    e.preventDefault();
  });

  $('.guide-btn5').click(function (e) {
    ManagePage.setPage(5);
    e.preventDefault();
  });

  $('.guide-btn6').click(function (e) {
    ManagePage.setPage(6);
    e.preventDefault();
  });
})();
